export const LOAD_NEW_DATA = 'containers/NewPage/LOAD_NEW_DATA';
export const LOAD_NEW_DATA_SUCCESS = 'containers/NewPage/LOAD_NEW_DATA_SUCCESS';
export const LOAD_NEW_DATA_ERROR = 'containers/NewPage/LOAD_NEW_DATA_ERROR';

export const FILTER_PER_PAGE = 'containers/NewPage/FILTER_PER_PAGE';
export const CHANGE_PAGE = 'containers/NewPage/CHANGE_PAGE';
